export const isAuthenticated = (auth) => {
    return auth.token && auth.isVerified
};


export const generateId = (deviceId, localIncrement) => {
    return deviceId * Math.pow(2, 22) + localIncrement
};

export const getAuthorizationHeader = (authState) => {
    return {'Authorization': 'Device-Token ' + authState.token}
};


// WEBPACK FOOTER //
// ./src/store/auth/utils.js